import PropTypes from "prop-types";

import { chartNames, strCode } from "../../../../consts";
import { deviceUtil, rumEventsUtil } from "../../../../utils";

import { DashboardBarChart, GradientLoader } from "../../../../components";
import { DashboardTemplate } from "../../../../templates";
import { MetricMainValue } from "../styled";

const ADStatisticsChart = ({
  diagnostics,
  getChartFilter = () => {},
  getIsLoading = () => {},
  getIsError = () => {}
}) => {
  return (
    <DashboardTemplate
      id={chartNames.AD_STATISTICS}
      title={strCode.AD_STATISTICS_TITLE}
      isLoading={getIsLoading(chartNames.AD_STATISTICS)}>
      <MetricMainValue>
        {getIsLoading(chartNames.AD_STATISTICS) ? (
          <GradientLoader width={120} height={32} />
        ) : (
          diagnostics?.total
        )}
      </MetricMainValue>

      <DashboardBarChart
        data={diagnostics?.statistics}
        isLoading={getIsLoading(chartNames.AD_STATISTICS)}
        isError={getIsError(chartNames.AD_STATISTICS)}
        yAxisLabel={strCode.COUNT_LABEL}
        metricsConfig={rumEventsUtil.getMetricsConfig({
          chartName: chartNames.AD_STATISTICS,
          deviceType: deviceUtil.getDeviceTypesByName(
            getChartFilter(chartNames.AD_STATISTICS)
              ? getChartFilter(chartNames.AD_STATISTICS)[0]
              : null
          ),
          coloredMetrics: {
            mono: "mono",
            charger: "charger",
            holder: "holder"
          }
        })}
        isCustomTicks
        deleteNullMetrics
      />
    </DashboardTemplate>
  );
};

ADStatisticsChart.propTypes = {
  diagnostics: PropTypes.shape({
    total: PropTypes.number.isRequired,
    statistics: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        metrics: PropTypes.objectOf(PropTypes.number).isRequired
      })
    ).isRequired
  }).isRequired,
  getChartFilter: PropTypes.func.isRequired,
  getIsLoading: PropTypes.func.isRequired,
  getIsError: PropTypes.func.isRequired
};

export default ADStatisticsChart;
